import { useEffect } from "react";
import { PAGES, SITE_URL, OG_IMAGE, buildJsonLd } from "../seo";

const setMeta = (selector, content) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", content);
};

// Updates the static <head> tags from index.html per route (no duplicates) and injects page JSON-LD.
export const Seo = ({ page }) => {
  const meta = PAGES[page];
  const url = `${SITE_URL}${meta.path}`;

  useEffect(() => {
    document.title = meta.title;
    document.head.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
    setMeta('meta[name="description"]', meta.description);
    setMeta('meta[property="og:title"]', meta.title);
    setMeta('meta[property="og:description"]', meta.description);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:image"]', OG_IMAGE);
    setMeta('meta[name="twitter:title"]', meta.title);
    setMeta('meta[name="twitter:description"]', meta.description);
    setMeta('meta[name="twitter:image"]', OG_IMAGE);
  }, [meta, url]);

  return (
    <script
      type="application/ld+json"
      data-testid={`jsonld-${page}`}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(buildJsonLd(page)) }}
    />
  );
};
